import React, { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue, remove } from "firebase/database";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import UElogo from "../assets/UElogo_horizontal.png";
import Papa from "papaparse"; // CSV Parser
import {
  fetchAdminLevels,
  getAdminLevel,
  getUserType,
  isAdmin,
  isAllowedDomain,
} from "../utils/userAccess";
import {
  canAccessPage,
  canUploadFiles,
  reservationRules,
} from "../utils/accessRules";import { House } from "lucide-react";
import { CalendarClock } from "lucide-react";
import { LogOut } from "lucide-react";
import { UserRoundCheck } from "lucide-react";
import DatePicker from "react-datepicker";
import { Calendar1 } from "lucide-react";
import { CalendarSearch } from "lucide-react";
import { CloudUpload } from "lucide-react";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/datepicker-dark.css";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAaR9ZU1w_bFxMKMbNxu-9eBpuOOGm1Eow",
  authDomain: "bookingappv1-d1e2d.firebaseapp.com",
  databaseURL: "https://bookingappv1-d1e2d-default-rtdb.firebaseio.com/",
  projectId: "bookingappv1-d1e2d",
  storageBucket: "bookingappv1-d1e2d.appspot.com",
  messagingSenderId: "134532713601",
  appId: "1:134532713601:web:5ad89fec3f4bf09b519180",
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

export default function ReservationPageB() {
  const [reservations, setReservations] = useState({});
  const [restrictedSchedules, setRestrictedSchedules] = useState([]);
  const [unavailableSchedules, setUnavailableSchedules] = useState([]);
  const [roomAccess, setRoomAccess] = useState({});
  const [rooms, setRooms] = useState([]);
  const [user, setUser] = useState(null);
  const [currentDay, setCurrentDay] = useState(new Date().getDay());
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  const normalizeTime = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return `${hours.toString().padStart(2, "0")}:${minutes
.toString()
.padStart(2, "0")}`;
  };

  const normalizeWeekDates = (weeks, weekdayName) => {
    const daysMapping = {
      Domingo: 0,
      Segunda: 1,
      Terça: 2,
      Quarta: 3,
      Quinta: 4,
      Sexta: 5,
      Sábado: 6,
    };

    if (!daysMapping.hasOwnProperty(weekdayName)) return [];

    return weeks.map((weekStart) => {
      let startDate = new Date(weekStart);
      let correctedDate = new Date(startDate);
      correctedDate.setDate(
        startDate.getDate() + (daysMapping[weekdayName] - 1),
      );
      return correctedDate.toISOString().split("T")[0];
    });
  };

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const email = user.email;

        const adminMap = await fetchAdminLevels();
        const level = getAdminLevel(email, adminMap);
        const type = getUserType(email);

        setUserData({
          email,
          adminLevel: level,
          userType: type,
          canUpload: canUploadFiles(level),
          reservationRules: reservationRules(level),
        });

        setUser(user);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const reservationsRef = ref(db, "reservations/buildingB");
    onValue(reservationsRef, (snapshot) => {
      setReservations(snapshot.val() || {});
    });
  }, []);

  useEffect(() => {
    const schedulesRef = ref(db, "uploads/class_schedulesB");
    onValue(schedulesRef, (snapshot) => {
      const content = snapshot.val()?.content;
      if (!content) return;
      Papa.parse(content, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const parsedData = result.data.map((row) => ({
            ...row,
            Week: normalizeWeekDates(
              row.Week.split(","),
              row.WeekdayName.trim(),
            ),
            WeekdayName: row.WeekdayName.trim(),
          }));
          setRestrictedSchedules(parsedData);
        },
      });
    });
  }, []);

  useEffect(() => {
    const unavailableRef = ref(db, "uploads/unavailable_schedules");
    onValue(unavailableRef, (snapshot) => {
      const content = snapshot.val()?.content;
      if (!content) return;
      Papa.parse(content, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const processed = [];
          result.data.forEach((row) => {
            const classroom = row.Classroom?.trim();
            const start = row.StartTime ? normalizeTime(row.StartTime) : "00:00";
const end   = row.EndTime   ? normalizeTime(row.EndTime)   : "24:00";
            const fromDate = row.FromDate?.trim();
            const toDate = row.ToDate?.trim();
            const recurring = row.Recurring?.trim();
            const from = new Date(fromDate);
            const to = new Date(toDate);

            // Helpers: parse/format strictly in LOCAL time (Europe/Lisbon via the browser)
function parseYMDLocal(ymd) {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, m - 1, d); // local midnight
}
function formatYMDLocal(d) {
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
}

// 0=Sun..6=Sat (local)
const isRecurringMatch = (dayIndex, recurring) =>
  !recurring ||
  (recurring === "Sun" && dayIndex === 0) ||
  (recurring === "Mon" && dayIndex === 1) ||
  (recurring === "Tue" && dayIndex === 2) ||
  (recurring === "Wed" && dayIndex === 3) ||
  (recurring === "Thu" && dayIndex === 4) ||
  (recurring === "Fri" && dayIndex === 5) ||
  (recurring === "Sat" && dayIndex === 6) ||
  (recurring === "Mon-Thu" && dayIndex >= 1 && dayIndex <= 4) ||
  (recurring === "Mon-Fri" && dayIndex >= 1 && dayIndex <= 5) ||
  (recurring === "Sat-Sun" && (dayIndex === 6 || dayIndex === 0));

// Inside your parse loop:
for (
  let d = parseYMDLocal(fromDate);
  d <= parseYMDLocal(toDate);
  d.setDate(d.getDate() + 1)
) {
  const dayIndex = d.getDay();        // LOCAL weekday
  const dateStr = formatYMDLocal(d);  // LOCAL YYYY-MM-DD (no toISOString!)

  if (isRecurringMatch(dayIndex, recurring?.trim())) {
    processed.push({
      Classroom: classroom?.trim(),
      StartTime: start,
      EndTime: end,
      Week: [dateStr],
    });
  }
}

          });
          setUnavailableSchedules(processed);
        },
      });
    });
  }, []);

  useEffect(() => {
    const accessRef = ref(db, "uploads/room_access");
    onValue(accessRef, (snapshot) => {
      const content = snapshot.val()?.content;
      if (!content) return;
      Papa.parse(content, {
        header: true,
        delimiter: ";",
        skipEmptyLines: true,
        complete: (result) => {
          const accessData = {};
          result.data.forEach((row) => {
            const classroom = row.Classroom?.trim();
            if (!classroom) return;
            const accessRules = [];
            if (row.Allowed1) {
              accessRules.push({
                type: row.Allowed1.trim().toLowerCase(),
                from: row.FromDate1?.trim() || null,
                to: row.ToDate1?.trim() || null,
              });
            }
            if (row.Allowed2) {
              accessRules.push({
                type: row.Allowed2.trim().toLowerCase(),
                from: row.FromDate2?.trim() || null,
                to: row.ToDate2?.trim() || null,
              });
            }
            accessData[classroom] = accessRules;
          });
          setRoomAccess(accessData);
        },
      });
    });
  }, []);

  useEffect(() => {
    const roomsRef = ref(db, "uploads/rooms");
    onValue(roomsRef, (snapshot) => {
      const content = snapshot.val()?.content;
      if (!content) return;
      try {
        const parsed = JSON.parse(content);
        if (parsed.buildingB) setRooms(parsed.buildingB);
      } catch (err) {
        console.error("Error parsing rooms.json:", err);
      }
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.menu-dropdown')) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const isRoomAccessible = (room, userType, date = new Date()) => {
    const accessRules = roomAccess[room] || [];
    const dateStr = date.toISOString().split("T")[0];

    return accessRules.some((rule) => {
      if (rule.type !== userType) return false;
      if (!rule.from && !rule.to) return true; // Always allowed
      if (rule.from && dateStr < rule.from) return false;
      if (rule.to && dateStr > rule.to) return false;
      return true;
    });
  };

  const handleReserve = (room, time) => {
    if (!user) {
      alert("Please log in to make a reservation.");
      return;
    }

    const isStudent = user.email.endsWith("@alunos.uevora.pt");
    const userType = isStudent ? "students" : "faculty";
    const isAdminUser = userData?.adminLevel === 1 || userData?.adminLevel === 2;
    const rules = reservationRules(userData?.adminLevel);
    const dateKey = currentDate.toISOString().split("T")[0];
    const timeKey = time;

    // ⛔ Check if room is accessible (for non-admins)
    const allowed = isAdminUser || isRoomAccessible(room, userType, currentDate);
    if (!allowed) {
      alert("You do not have permission to book this room.");
      return;
    }

    // ⛔ Check student reservation rules (levels 3 or 4)
    if ([3, 4].includes(userData?.adminLevel)) {
      const now = new Date();
      const targetDay = new Date(currentDate);

      now.setHours(0, 0, 0, 0);
      targetDay.setHours(0, 0, 0, 0);

      const isToday = now.getTime() === targetDay.getTime();
      const isTomorrow =
        targetDay.getTime() - now.getTime() === 24 * 60 * 60 * 1000;

      if (userData?.adminLevel === 3 && !isToday) {
        alert("Level 3 students can only reserve for today.");
        return;
      }

      if (userData?.adminLevel === 4) {
        const currentHour = new Date().getHours();
        if (!isTomorrow || currentHour < 22) {
          alert("Level 4 students can only reserve for tomorrow after 22h.");
          return;
        }
      }

      // ⛔ Only one room per time slot
      const alreadyReserved = Object.values(reservations).some(
        (roomReservations) =>
          roomReservations?.[dateKey]?.[timeKey]?.email === user.email
      );
      if (alreadyReserved) {
        alert("You can only reserve one room at the same time.");
        return;
      }

      // ⛔ Enforce max hours per period
      const morningHours = [];
      const afternoonHours = [];

      for (const [r, times] of Object.entries(reservations)) {
        const dayReservations = times?.[dateKey];
        if (!dayReservations) continue;

        for (const [t, res] of Object.entries(dayReservations)) {
          if (res?.email === user.email) {
            const hour = parseInt(t.split(":")[0]);
            if (hour < 14) morningHours.push(t);
              else afternoonHours.push(t);
          }
        }
      }

      const hour = parseInt(time.split(":")[0]);
      const maxMorning = rules?.maxHoursMorning || 2;
      const maxAfternoon = rules?.maxHoursAfternoon || 2;

      if (hour < 14 && morningHours.length >= maxMorning) {
        alert(`You can only reserve ${maxMorning} hours in the morning.`);
        return;
      }

      if (hour >= 14 && afternoonHours.length >= maxAfternoon) {
        alert(`You can only reserve ${maxAfternoon} hours in the afternoon.`);
        return;
      }
    }

    // ✅ Reserve
    set(ref(db, `reservations/buildingB/${room}/${dateKey}/${timeKey}`), {
      status: "Reserved",
      email: user.email,
      user: user.displayName,
    });
  };

  const handleCancel = (room, time) => {
    if (!user) {
      alert("Please log in to cancel a reservation.");
      return;
    }

    const dateKey = currentDate.toISOString().split("T")[0];
    const reservation = reservations[room]?.[dateKey]?.[time];

    if (!reservation) {
      alert("No reservation found.");
      return;
    }

    const isOwnReservation = reservation.email === user.email;
    const level = userData?.adminLevel;
    const isAdminFull = level === 1;
    const isAdminGeneral = level === 2;
    const isStudent = level === 3 || level === 4;

    // ✅ Check if reservation is in the past
    const reservationDateTime = new Date(`${dateKey}T${time}`);
    const now = new Date();
    const isPast = reservationDateTime < now;

    // ⛔ Block non-level-1 users from canceling past reservations
    if (isPast && level !== 1) {
      alert("You do not have permission to cancel past reservations.");
      return;
    }

    // ✅ Admins cancel others
    if ((isAdminFull || isAdminGeneral) && !isOwnReservation) {
      set(ref(db, `reservations/buildingB/${room}/${dateKey}/${time}`), {
        status: "Removed",
        admin: user.email,
      })
        .then(() =>
          console.log(
            `Admin ${user.email} removed a reservation for ${reservation.email}`
          )
        )
        .catch((error) => console.error("Admin remove error: ", error));
    }

    // ✅ Users/admins cancel own
    else if (isOwnReservation && (isAdminFull || isStudent)) {
      remove(ref(db, `reservations/buildingB/${room}/${dateKey}/${time}`))
        .then(() =>
          console.log(`User ${user.email} canceled their reservation`)
        )
        .catch((error) => console.error("Cancellation error: ", error));
    }

    // ❌ Not allowed
    else {
      alert("You can only cancel your own reservations.");
    }
  };

  const scheduleTimes = Array.from({ length: 16 }, (_, i) => `${8 + i}:00`);

  const changeDay = (direction) => {
    setCurrentDay((prevDay) => (prevDay + direction + 7) % 7);
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(prevDate.getDate() + direction);
      return newDate;
    });
  };

  const dateKey = currentDate.toISOString().split("T")[0];

  const formattedDate = `${currentDate.getDate()} of ${currentDate.toLocaleString("default", { month: "long" })} of ${currentDate.getFullYear()}`;

  const handleSignOut = () => {
    signOut(auth).then(() => navigate("/"));
  };
  const goToBuildings = () => {
    navigate("/buildings");
  };
  const goToMyReservations = () => {
    navigate("/my-reservations");
  };
  const goToAdminReservations = () => {
    navigate("/admin-reservations");
  };
  const goToContact = () => {
    navigate("/contact");
  };
  const goToTerms = () => {
    navigate("/terms-of-use");
  };

  return (
    <div className="flex flex-col p-6 pt-28 w-full bg-gray-800 text-gray-100 min-h-screen">
      <div className="w-full flex justify-between items-center px-6 py-4 absolute top-0 left-0">
        {/* Logo on the left */}
        <img src={UElogo} alt="UE Logo" className="h-12 w-auto" />

        {/* Buttons on the right */}
        <div className="flex gap-4 items-center relative">
          {/* Hamburger Menu Button */}
          <div className="relative menu-dropdown">
            <button
              onClick={() => setShowMenu((prev) => !prev)}
              className="bg-gray-600 text-white px-2 py-1 hover:bg-gray-700 text-sm w-fit shadow-md rounded"
              title="Menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* Dropdown Content */}
            {showMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-gray-900 border border-gray-700 rounded-lg shadow-lg z-50">
                <button
                  onClick={goToBuildings}
                  className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                >
                  <div className="flex gap-2">
                    <House className="w-5 h-5 text-white" />
                    Home
                  </div>
                </button>
                <button
                  onClick={goToMyReservations}
                  className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                >
                  <div className="flex gap-2">
                    <CalendarClock className="w-5 h-5 text-white" />
                    My Reservations
                  </div>
                </button>
                {[1, 2].includes(userData?.adminLevel) && (
                  <button
                    onClick={goToAdminReservations}
                    className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                  >
                    <div className="flex gap-2 text-purple-500">
                      <CalendarSearch className="w-5 h-5 text-purple-500" />
                      All Reservations
                    </div>
                  </button>
                )}
                {userData?.adminLevel === 1 && (
                  <button
                    onClick={() => navigate("/admin-upload")}
                    className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                  >
                    <div className="flex gap-2 text-purple-500">
                      <CloudUpload className="w-5 h-5 text-purple-500" />
                      Upload
                    </div>
                  </button>
                )}
                <button
                  onClick={handleSignOut}
                  className="block w-full text-left px-4 py-2 text-red-400 hover:bg-red-900"
                >
                  <div className="flex gap-2">
                    <LogOut className="w-5 h-5 text-red-400" />
                    Sign Out
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="w-full mb-8 text-left px-6">
        <h1 className="text-xl font-bold">Reservations for Complexo dos Leões</h1>
      </div>

      <div className="flex justify-center items-center mb-4 relative">
        {/* ⬅️ ⬅️ ⬅️ Centered controls */}
        <div className="flex items-center gap-4">
          <button
            onClick={() => changeDay(-1)}
            className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-1.5 rounded"
          >
            ⬅
          </button>

          <h2 className="text-lg font-semibold text-white">{formattedDate}</h2>

          <button
            onClick={() => changeDay(1)}
            className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-1.5 rounded"
          >
            ➡
          </button>
        </div>

        {/* 📅 Button positioned on the far right */}
        <div className="absolute right-0">
          <button
            onClick={() => setIsModalOpen(true)}
            className="text-white px-3 py-1.5 rounded bg-purple-800 hover:bg-purple-900"
          >
            <div className="flex gap-2">
              Select a Date
              <Calendar1 className="w-5 h-5 text-white" />
            </div>
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-600">
          <thead>
            <tr className="bg-gray-700 text-white">
              <th className="border border-gray-600 p-2 text-left">
                Classroom
              </th>
              {scheduleTimes.map((time) => (
                <th
                  key={time}
                  className="border border-gray-600 p-2 text-center"
                >
                  {time}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rooms.map((room) => (
              <tr key={room} className="bg-gray-800 text-white">
                <td className="border border-gray-600 p-3 text-left flex items-center gap-2">
                  {room}
                  {isRoomAccessible(room, "students", currentDate) && (
                    <UserRoundCheck
                      className="w-4 h-4 text-green-400"
                      title="Reservable by students"
                    />
                  )}
                </td>
                {scheduleTimes.map((time) => {
                  // Check if the schedule is restricted
                  const restrictedSchedule = restrictedSchedules.find(
                    (res) =>
                      res.Classroom === room &&
                        res.Week.includes(dateKey) &&
                        normalizeTime(time) >= normalizeTime(res.StartTime) &&
                        normalizeTime(time) < normalizeTime(res.EndTime),
                  );

                  const unavailableSchedule = unavailableSchedules.find(
  (res) =>
    (res.Classroom === room || res.Classroom?.toUpperCase() === "ALL") &&
    res.Week.includes(dateKey) &&
    normalizeTime(time) >= normalizeTime(res.StartTime) &&
    normalizeTime(time) < normalizeTime(res.EndTime),
);

                  console.log("Unavailable:", unavailableSchedules);
                  console.log("Date Key:", dateKey);

                  // Check if the time slot is reserved
                  const reservation = reservations[room]?.[dateKey]?.[time];
                  const isReserved = !!reservation;
                  const isRemovedByAdmin = reservation?.status === "Removed";
                  const isRestricted = !!restrictedSchedule;
                  const isUnavailable = !!unavailableSchedule;

                  return (
                    <td
                      key={time}
                      className="border border-gray-600 p-2 text-center"
                    >
                      <div className="flex justify-center items-center w-full">
                        {/* 🟡 Handle Restricted Schedules First */}
                        {isRestricted ? (
                          <div
                            className="w-8 h-8 flex justify-center items-center bg-yellow-500 text-white rounded"
                            title={restrictedSchedule.ModuleName} // Show Module Name on Hover
                          >
                            ✖
                          </div>
                        ) : isUnavailable ? (
                            /* ⚫ Handle Restricted Schedules First */
                            <div
                              className="w-8 h-8 flex justify-center items-center bg-gray-700 text-white rounded"
                              title="Unavailable Time"
                            >
                              ✖
                            </div>
                          ) : isRemovedByAdmin ? (
                              /* 🟣 Admin Removed Slot */
                              <button
                                className="w-8 h-8 flex justify-center items-center bg-purple-500 text-white rounded"
                                title={`This reservation was removed by ${reservation.admin}`} // Show Admin who removed it
                                onClick={() => handleReserve(room, time)} // Allow Rebooking
                              >
                                ✔
                              </button>
                            ) : (
                                /* 🟢 Normal Reservation Handling */
                                <button
                                  className={`w-8 h-8 flex justify-center items-center rounded ${isReserved ? "bg-red-500" : "bg-green-500"} text-white`}
                                  onClick={() =>
                                    isReserved
                                      ? handleCancel(room, time)
                                      : handleReserve(room, time)
                                  }
                                >
                                  {isReserved ? "✖" : "✔"}
                                </button>
                              )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>

        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gray-800 text-white rounded-lg p-6 shadow-lg w-[350px]">
              <h3 className="text-lg font-semibold mb-4 text-center">
                Select a Date
              </h3>

              <div className="flex flex-col items-center">
                <DatePicker
                  selected={currentDate}
                  onChange={(date) => {
                    setCurrentDate(date);
                    setCurrentDay(date.getDay());
                    setIsModalOpen(false);
                  }}
                  inline
                />

                <button
                  onClick={() => setIsModalOpen(false)}
                  className="mt-4 w-32 bg-red-500 hover:bg-red-600 text-white py-2 rounded"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Contact and Term of Use Link */}
      <div className="mt-auto flex gap-[1cm] justify-center">
        <button
          onClick={goToContact}
          className="mt-auto pt-[1cm] text-sm text-gray-400 text-center"
        >
          Contact
        </button>
        <button
          onClick={goToTerms}
          className="mt-auto pt-[1cm] text-sm text-gray-400 text-center"
        >
          Terms of Use
        </button>
      </div>
    </div>
  );
}

